// import { InMemoryCache } from "@apollo/client/react"
// import { relayStylePagination } from "@apollo/client/utilities";
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
  SSRMultipartLink,
} from "@apollo/client-integration-nextjs"

import {
  successMessageVar,
  warningMessageVar,
  errorMessageVar,
  signUpEmailVar,
  isViewWebsiteAsMemberOrLeaderVar,
  leaderSessionDetailPageVars,
  leaderCohortDetailPageVars,
  leaderGroupDetailPageVars,
  leaderDashboardPageVars,
  memberCohortDetailPageVars,
} from "./reactiveVars"
import { JWT_TOKEN } from "../lib/constants"

import { merge, read } from "../lib/apollo/apolloClientRelayPagination"

type SnackbarMessageState = {
  message: string
  duration: number
}

function normalizeSnackbarMessage(
  message: string | SnackbarMessageState | null,
): SnackbarMessageState | null {
  return typeof message === "string" ? { message, duration: 3000 } : message
}

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        provider: {
          keyArgs: false, // Depends on your data structure; set to false if the entire object needs to be considered for caching
          merge(existing, incoming, { mergeObjects }) {
            // Custom logic to merge existing and incoming provider data
            return mergeObjects(existing, incoming)
          },
        },
        successMessage: {
          read() {
            return normalizeSnackbarMessage(successMessageVar())
          },
        },
        warningMessage: {
          read() {
            return normalizeSnackbarMessage(warningMessageVar())
          },
        },
        errorMessage: {
          read() {
            return normalizeSnackbarMessage(errorMessageVar())
          },
        },
        signUpEmail: {
          read() {
            return signUpEmailVar()
          },
        },
        listSessions: {
          read: read,
          merge: merge,
        },
        listUser: {
          read: read,
          merge: merge,
        },
        adminListGroup: {
          read: read,
          merge: merge,
        },
        getCohorts: {
          read: read,
          merge: merge,
        },
        isViewWebsiteAsMemberOrLeader: {
          read() {
            return isViewWebsiteAsMemberOrLeaderVar()
          },
        },
        leaderSessionDetailPageVars: {
          read() {
            return leaderSessionDetailPageVars()
          },
        },
        leaderCohortDetailPageVars: {
          read() {
            return leaderCohortDetailPageVars()
          },
        },
        leaderGroupDetailPageVars: {
          read() {
            return leaderGroupDetailPageVars()
          },
        },
        leaderDashboardPageVars: {
          read() {
            return leaderDashboardPageVars()
          },
        },
        memberCohortDetailPageVars: {
          read() {
            return memberCohortDetailPageVars()
          },
        },
      },
    },
    Provider: {
      // Ensure each provider has a unique identifier
      keyFields: ["id"],
    },
  },
  // Add possibleTypes for fragment matching in Apollo Client 4
  possibleTypes: {
    // Add your union and interface types here if you have any
    // Example:
    // SearchResult: ["User", "Group", "Post"],
  },
})
